@if(!field()){
<code>Loading...</code>
}
@else{
<label [for]="field().fieldId.toString()">{{ label }}</label>
<mat-form-field>
  <textarea rows="4" matInput
            [id]="field().fieldId.toString()"
            [placeholder]="label!"
            [formControl]="formControl"
            [attr.aria-describedby]="field().fieldId.toString() + '-hint'"
            [attr.aria-labelledby]="field().fieldId.toString() + '-label'"
            [attr.aria-invalid]="formControl.invalid ? 'true' : 'false'"
            autocomplete="off"
            aria-autocomplete="none"
            list="autocomplete-off">
    </textarea>
  <mat-hint [attr.id]="field().fieldId.toString() + '-hint'">Enter your response</mat-hint>
  @if(formControl.errors?.['required']){
  <mat-error [attr.id]="field().fieldId.toString() + '-error'" aria-live="assertive">
    {{ label }} is <strong>required</strong>
  </mat-error>
  }
</mat-form-field>
}
